
import {getRoleEnum, Role} from "@/data/models/roles/role.enum";
import {userEmailRules} from "@/data/rules/UserRules";
import Vue from "vue";

export default Vue.extend({
  name: "invitation-creation",
  props: {projectId: Number, dialogOpened: Boolean},
  data() {
    return {
      email: "" as string,
      emailRules: userEmailRules(),
      roles: [],
      role: null,
      loading: false,
      sourceLanguagesIds: [],
      targetLanguagesIds: []
    };
  },
  computed: {
    languages(): any[] {
      return this.$store.getters.currentProject.languages.map((language: any) => {
        return {
          text: language.name,
          value: language.id
        }
      });
    },
    canShowSourceAndTargetLanguages(): boolean {
      return this.role === Role.TRANSLATOR || this.role === Role.REVIEWER;
    }
  },
  watch: {
    dialogOpened: {
      immediate: true,
      handler: function (isOpened) {
        if (isOpened) {
          //ON RE-OPENED, RESET DATA
          this.email = "";
          this.role = null;
          this.roles = this.constructRoles();
          this.sourceLanguagesIds = [];
          this.targetLanguagesIds = [];
        }
      }
    }
  },
  methods: {
    constructRoles(): any[] {
      const res: any[] = [];
      Object.values(Role).forEach((role: string) => {
        if (role === Role.OWNER) {
          return;
        }
        res.push({
          text: this.$t(`users_manage.role_${getRoleEnum(role)}`),
          value: role
        });
      });
      return res;
    },
    closeOverlay() {
      this.$emit("closeInvitation");
    },
    inviteUser() {
      if ((this.$refs.formCreateInvitation as any).validate() === true) {
        if (this.role === null || this.role === "") {
          this.$notify(this.$t("errors.enter_role").toString(), {color: "red"});
        } else {
          this.loading = true;
          if (!this.canShowSourceAndTargetLanguages) {
              this.sourceLanguagesIds = [];
              this.targetLanguagesIds = [];
          }

          this.$service.invitations.createInvitation(this.projectId, this.email, this.role, this.sourceLanguagesIds, this.targetLanguagesIds)
              .then(() => {
                this.$notify(this.$t("success.invitation_created").toString(), {color: "primary"});
                this.closeOverlay();
                this.$emit('invitationSent');
              })
              .catch((e) => {
                this.$notify(this.$t(e).toString(), {color: "red"});
                this.email = "";
                this.role = null;
              })
              .finally(() => this.loading = false);
        }
      }
    }
  },

});
